<script setup lang="ts">
import { ComparatorAnalysis } from "@types"
import { useI18n } from "vue-i18n"

type Props = {
    value: ComparatorAnalysis
}

const { t } = useI18n({
    messages: {
        fr: {
            title: "Résultat de la comparaison",
        },
    },
})

defineProps<Props>()

const [visible] = defineModel<boolean>("visible", {
    required: true,
    default: false,
})
</script>

<template>
    <BaseDialog
        v-model:visible="visible"
        modal
        :closable="true"
        position="top"
        dismissable-mask
        class="modal-result-comparator"
        :style="{ width: '90vw' }"
    >
        <template #header>
            <h2 class="text-lg text-primary font-semibold">
                {{ t("title") }}
            </h2>
        </template>
        <ComparatorResultCard
            :output="value?.outputs"
            :name="value.name"
            disabled-save
            disabled-edit-name
            disabled-export
            :created-at="new Date(value.created_at)"
        />
    </BaseDialog>
</template>

<style scoped></style>
